import styled from "styled-components";
import { getPropertyByMedia } from "../helpers";
import LogoDarkestImg from "./images/darkest.png";
import LogoDarkestBrandImg from "./images/darkest_brand.png";
import LogoDarkestVerticalImg from "./images/darkest_vertical.png";
import LogoNeutralDarkImg from "./images/neutral_dark.png";
import LogoNeutralDarkVerticalImg from "./images/neutral_dark_vertical.png";
import LogoNeutralWhiteImg from "./images/neutral_white.png";
import LogoNeutralWhiteVerticalImg from "./images/neutral_white_vertical.png";
import LogoPrimaryImg from "./images/primary.png";
import LogoPrimaryVerticalImg from "./images/primary_vertical.png";
import LogoSecondaryImg from "./images/secondary.png";
import LogoSecondaryVerticalImg from "./images/secondary_vertical.png";
export const LogoContainer = styled.img `
	${({ maxWidth }) => getPropertyByMedia("max-width", maxWidth)}
	${({ width }) => getPropertyByMedia("width", width)}
	${({ display }) => getPropertyByMedia("display", display)}
`;
const getImageAttributes = (format, image, rowImage) => ({
    src: format === "row" ? rowImage : image,
});
const getImageAttributesBrand = (format, image, rowImage, brandImage) => {
    if (format === "brand")
        return { src: brandImage };
    if (format === "row")
        return { src: rowImage };
    return {
        src: image,
    };
};
export const LogoDarkest = styled(LogoContainer).attrs(({ format }) => getImageAttributesBrand(format, LogoDarkestVerticalImg, LogoDarkestImg, LogoDarkestBrandImg)) ``;
export const LogoNeutralDark = styled(LogoContainer).attrs(({ format }) => getImageAttributes(format, LogoNeutralDarkVerticalImg, LogoNeutralDarkImg)) ``;
export const LogoPrimary = styled(LogoContainer).attrs(({ format }) => getImageAttributes(format, LogoPrimaryVerticalImg, LogoPrimaryImg)) ``;
export const LogoSecondary = styled(LogoContainer).attrs(({ format }) => getImageAttributes(format, LogoSecondaryVerticalImg, LogoSecondaryImg)) ``;
export const LogoNeutralWhite = styled(LogoContainer).attrs(({ format }) => getImageAttributes(format, LogoNeutralWhiteVerticalImg, LogoNeutralWhiteImg)) ``;
//# sourceMappingURL=styles.js.map